module.exports = __webpack_public_path__ + "img/video.74c0734f.svg";